import { SliceClass } from 'interfaces';
import {
  ProductBoxDocumentDataBodyFeaturesSlice,
  ProductBoxDocumentDataBodyFeaturesSliceItem,
} from '../types.generated.interface';

export class ProductBoxFeatures extends SliceClass {
  public section_title: string;
  public section_icon: string;
  public items: ProductBoxDocumentDataBodyFeaturesSliceItem[];

  constructor(sliceData: ProductBoxDocumentDataBodyFeaturesSlice) {
    super(sliceData);
    this.section_title = sliceData.primary.section_title;
    this.section_icon = sliceData.primary.section_icon;
    this.items = sliceData.items;
  }
}
